import { getTimeslotByHours, getTimeslotByMinutesRange, selectTimeslotsMap } from "entities/toolbar/timeslots";
import { useAppSelector } from "shared/lib/store";
import { formatTime } from "shared/lib/time";

export const useCurrentSlotTime = () => {
    const formattedTime = formatTime({ day: new Date(), byUtc: false });
        const timeslotsMap = useAppSelector(selectTimeslotsMap);

    const getCurrentTime = () => {
        if (formattedTime) {
            const { hours } = formattedTime;
            const slotsByHours = getTimeslotByHours(timeslotsMap, hours);
            if (slotsByHours) {
                const slotByTime = getTimeslotByMinutesRange(
                    slotsByHours,
                    new Date(),
                );
                if (slotByTime) {
                    const formatedTime = formatTime({
                        time: slotByTime.dt_start,
                    });
                    if (formatedTime) {
                        const timeText = formatedTime.time;
                        return timeText;
                    }
                } else {
                    return `${hours}:00`
                }
            } else {
                return `${hours}:00`
            }
        }
    }

    return {
        getCurrentTime
    }
}